import { render, staticRenderFns } from "./ordermanage.vue?vue&type=template&id=05dedbb0&scoped=true"
import script from "./ordermanage.vue?vue&type=script&lang=js"
export * from "./ordermanage.vue?vue&type=script&lang=js"
import style0 from "./ordermanage.vue?vue&type=style&index=0&id=05dedbb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dedbb0",
  null
  
)

export default component.exports